import { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartContext = createContext(null);

const STORAGE_KEY = "casacompleta_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch { return []; }
  });

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch {}
  }, [items]);

  const add = useCallback((product, variant = {}, cantidad = 1) => {
    setItems((prev) => {
      // Key único = product.id + variantes
      const key = `${product.id}|${variant.color || ""}|${variant.tela || ""}|${variant.tamano || ""}|${variant.estilo || ""}`;
      const idx = prev.findIndex((it) => it.key === key);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], cantidad: next[idx].cantidad + cantidad };
        return next;
      }
      // Precio EFECTIVO: si tiene precio_oferta vigente lo usamos, si no el precio normal (web)
      const precioNormal = Number(product.precio || 0);
      const precioOferta = product.precio_oferta != null ? Number(product.precio_oferta) : null;
      const precioEfectivo = (precioOferta != null && precioOferta > 0 && precioOferta < precioNormal) ? precioOferta : precioNormal;
      return [...prev, {
        key,
        id: product.id,
        nombre: product.nombre,
        precio: precioEfectivo,
        precio_normal: precioNormal,
        precio_oferta: precioOferta,
        en_oferta: precioEfectivo !== precioNormal,
        imagen: product.imagen || (product.imagenes && product.imagenes[0]) || "",
        color: variant.color || "",
        tela: variant.tela || "",
        tamano: variant.tamano || "",
        estilo: variant.estilo || "",
        cantidad,
      }];
    });
  }, []);

  const updateQty = useCallback((key, qty) => {
    setItems((prev) => prev.map((it) => it.key === key ? { ...it, cantidad: Math.max(1, qty) } : it));
  }, []);

  const remove = useCallback((key) => {
    setItems((prev) => prev.filter((it) => it.key !== key));
  }, []);

  const clear = useCallback(() => setItems([]), []);

  const totalItems = items.reduce((s, it) => s + it.cantidad, 0);
  const totalMonto = items.reduce((s, it) => s + it.cantidad * it.precio, 0);

  return (
    <CartContext.Provider value={{ items, add, updateQty, remove, clear, totalItems, totalMonto }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
}
